import React from "react";
import {field} from "@mc/mc-legacy";

type Props = {
    items: any,
}

class TypeCombinationField extends React.Component<Props> {

  render() {
    const { items, ...componentProps } = this.props;

    return (
      <field.Autocomplete
        {...componentProps}
        useIdAsValue
        getItemName={(item) => (item ? item.name : "")}
        items={items}
      />
    );
  }
}

export default TypeCombinationField;
